import { createActionWithPayload } from "store/helpers";
import { ActionTypes, IModeloDiarioPadrao } from "./types";

export const set = createActionWithPayload<IModeloDiarioPadrao>(
  ActionTypes.SET
);
